import { combineReducers } from 'redux';

import { createReducer } from '../utils/';
import constant from '../utils/constant';

const listHandlers = {
    [constant.TASKLISTGET](state, action){
        return action.payload;
    },
};

const stateHandlers = { // 所有状态
    [constant.LISTLOADING](state, action) {
        return { ...state, loading: action.payload };
    },
    [constant.PAGETOTAL](state, action) {
        return { ...state, pageTotal: action.payload };
    },
}

const taskIdHandlers = {
    [constant.GETTASKID](state, action) {
        return action.payload;
    },
}
export const List = createReducer([], listHandlers); // 活动列表
export const ListStatus = createReducer({ loading: false}, stateHandlers); // 所有状态
export const TaskId = createReducer('0', taskIdHandlers); // 所有状态

export const task = combineReducers({
    List,
    ListStatus,
    TaskId
})


// WEBPACK FOOTER //
// ./reducers/task.js